import type { ReactNode } from 'react';

import { LogCard } from './shared';
import type { LogCardAccordionItemClasses } from './shared/accordionStyles';
import type { AgentOutputMessageConfig } from '../utils/logParser';

import i18n from '~/common/helpers/i18n';

interface OutputMessageCardProps {
  config: AgentOutputMessageConfig;
  annotationSlot?: ReactNode;
  isExpanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  itemKey?: string;
  itemClasses?: LogCardAccordionItemClasses;
  className?: string;
}

/**
 * Component to display agent.output_message (LLM response / final output step) in a card.
 * This step is included in trace results so it can receive annotations.
 */
export function OutputMessageCard({
  config,
  annotationSlot,
  isExpanded,
  onExpandedChange,
  itemKey,
  itemClasses,
  className
}: OutputMessageCardProps) {
  const title = (
    <span className='text-sm font-semibold text-on-surface'>
      {i18n.t('scenes.build.execution.logs.output_message.label') as string}
    </span>
  );

  return (
    <LogCard
      title={title}
      textValue={
        i18n.t('scenes.build.execution.logs.output_message.label') as string
      }
      footer={annotationSlot}
      isExpanded={isExpanded}
      onExpandedChange={onExpandedChange}
      itemKey={itemKey}
      itemClasses={itemClasses}
      className={className}
    >
      <div className='max-h-96 overflow-y-auto rounded border border-outline p-4'>
        <pre className='whitespace-pre-wrap font-sans text-sm text-on-surface'>
          {config.content || ''}
        </pre>
      </div>
    </LogCard>
  );
}
